import React, { Component } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import "firebase/auth";
// var Binance = require("binance-api-node").default;

const Context = React.createContext();

// //binance
// var client = Binance();

class ContextProvider extends Component {
  state = {
    version: 1,
    isLoadingApp: true,
    user: null,
    isBannerDisplay: true,
    name: "",
    nickName: "",
    isProUser: false,
    isProPlusUser: false,
    api_key: "",
    binance_api_key: "",
    kucoin_api_key: "",
    telegram_id: "",
    email: "",
    maxBot: 0,
    isLoggedIn: false,
    uid: null,
    authError: "",
    realTimeData: true,
    exchangeData: {
      weeklyVolume: 0,
      todayVolume: 0,
      volume24H: 0,
      yesterdayVolume: 0,
    },
    pendingBots: [],
    activeBots: [],
    stoppedBots: [],
    telegram_notifications: {
      filled: true,
      pending: true,
      cancelled: true,
      insufficientFunds: true,
    },
    bots: [],
    summery: [],
    total: {
      volume: 0,
      dailyTrades: 0,
      bots: 0,
      dailyVolume: 0,
      yesterdayVolume: 0,
    },
    weeklyAccountBalances: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0 },
    totalBots: 0,
    usersCount: 0,
    maintenance: false,
    isRestricted: false,
    alert: { isAvailable: false, msg: "", type: "warning" },
  };
  componentDidMount() {
    this.authenticateUser();
    this.getMaintenance();
    this.getTotalUsers();
    this.getSummery();
  }
  getMaintenance = () => {
    firebase
      .database()
      .ref("/maintenance")
      .on("value", (snapshot) => {
        if (this.state.maintenance && !snapshot.val().maintenance) {
          window.location.reload();
          // console.log("reloaded");
        }
        if (this.state.version !== snapshot.val().version) {
          window.location.reload();
          // console.log("reloaded");
        }
        if (
          snapshot.val().maintenance &&
          "8HcYdjoSgpdLzE4TOIT0iKjZRJk1" !== this.state.uid
        ) {
          firebase.database().ref("/summery/").off();

          firebase
            .database()
            .ref("/userNotifications/" + this.state.uid + "/notifications")
            .orderByChild("createdAt")
            .off();
        }

        this.setState({
          maintenance:
            "8HcYdjoSgpdLzE4TOIT0iKjZRJk1" === this.state.uid
              ? false
              : snapshot.val().maintenance,
          version: snapshot.val().version,
        });
      });
  };
  getTotalUsers = () => {
    var userCountRef = firebase.database().ref("usersCount");
    userCountRef.on("value", (snapshot) => {
      this.setState({ usersCount: snapshot.numChildren() });
    });
  };
  getPendingBots = () => {
    var query = firebase
      .firestore()
      .collection("pendingBots")
      .where("uid", "==", this.state.uid);

    query.onSnapshot(
      (querySnapshot) => {
        var result = [];
        querySnapshot.forEach((doc) => {
          result.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        this.setState({ pendingBots: result });
      },
      (err) => {
        console.log(`Encountered error: ${err}`);
      }
    );
  };
  getBots = () => {
    var query = firebase
      .firestore()
      .collection("bots")
      .where("uid", "==", this.state.uid)
      .where("isDeleted", "==", false)
      .where("isPending", "==", false)
      .orderBy("displayId");
    query.onSnapshot(
      (querySnapshot) => {
        var active = [];
        var stop = [];
        var all = [];
        querySnapshot.forEach((doc) => {
          if (doc.data().isRunning) {
            active.push({
              ...doc.data(),
              id: doc.id,
            });
            all.push({
              ...doc.data(),
              id: doc.id,
            });
          } else {
            stop.push({
              ...doc.data(),
              id: doc.id,
            });
            all.push({
              ...doc.data(),
              id: doc.id,
            });
          }
        });
        if (active.length >= this.state.maxBot) {
          this.setState({
            activeBots: active,
            stoppedBots: stop,
            bots: all,
            alert: {
              isAvailable: true,
              msg:
                "You have reached the Max number of active and pending bots. Please stop running bots to create new bot.",
              type: "warning",
            },
          });
        } else {
          this.setState({
            activeBots: active,
            stoppedBots: stop,
            bots: all,
          });
        }
      },
      (err) => {
        console.log(`Encountered error: ${err}`);
      }
    );
  };
  compareTrades = (a, b) => {
    if (a.dailyVolume < b.dailyVolume) {
      return 1;
    }
    if (a.dailyVolume > b.dailyVolume) {
      return -1;
    }
    return 0;
  };
  getAccountBalancesData = async (uid) => {
    var data = await firebase
      .database()
      .ref("/accountBalances/" + uid)
      .once("value");
    // console.log(data.val());
    var weeklyAccountBalances = {};
    for (let index = 6; index > -1; index--) {
      var dateObj = new Date(new Date().setUTCHours(-index * 24, 0, 0, 0));
      var month = dateObj.getUTCMonth() + 1; //months from 1-12
      var day = dateObj.getUTCDate();

      var newdate = month + "/" + day;
      weeklyAccountBalances[newdate] = 0;
    }

    for (var dayB in data.val()) {
      // console.log(dayB);
      if (
        new Date(data.val()[dayB].createdAt) -
          new Date(new Date().setUTCHours(-6 * 24, 0, 0, 0)) >
          0 &&
        data.val()[dayB].nashChannelsBalance &&
        data.val()[dayB].nashChannelsBalance > 0
      ) {
        // console.log(weeklyAccountBalances);
        var dateObj2 = new Date(
          new Date(data.val()[dayB].createdAt).setUTCHours(0, 0, 0, 0)
        );
        var month2 = dateObj2.getUTCMonth() + 1; //month2s from 1-12
        var day2 = dateObj2.getUTCDate();

        var newdate2 = month2 + "/" + day2;
        weeklyAccountBalances[newdate2] = data.val()[dayB].nashChannelsBalance;
      }
    }
    this.setState({ weeklyAccountBalances: weeklyAccountBalances });
  };
  getSummery = async () => {
    firebase
      .database()
      .ref("/summery")
      .on("value", (snapshot) => {
        // console.log(snapshot.val()["main"]);
        var list = [];
        var total = {};
        var exchangeData = {};
        // console.log("summery received");

        for (var i in snapshot.val()["main"]) {
          if (i === "total") {
            total = snapshot.val()["main"][i];
          } else if (i === "exchangeData") {
            exchangeData = snapshot.val()["main"][i];
          } else {
            list.push({ market: i, ...snapshot.val()["main"][i] });
          }
        }
        // total["lastweekLeaderBoard"] = snapshot.val()["lastWeekData"];

        // var lastWeekVolume = 0;
        // total.lastweekLeaderBoard.forEach((element) => {
        //   lastWeekVolume += element.volume;
        // });
        // total["lastWeekVolume"] = lastWeekVolume;

        // console.log(total);

        this.setState({
          summery: list.sort(this.compareTrades),
          total: total,
          exchangeData: exchangeData,
        });
      });
  };
  authenticateUser = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            this.setState({
              user: user,
              email: user.email,
              uid: user.uid,
            });
            this.updateUserData(user);
            // this.getBotData();
            this.getBots();
            this.getPendingBots();

            this.getAccountBalancesData(user.uid);
            // this.getTotalBots();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.setState({
          isLoggedIn: false,
          user: null,
          isLoadingApp: false,
          uid: null,
          email: "",
          authError: "",
          name: "",
          api_key: "",

          telegram_id: "",
        });
      }
    });
  };
  updateUserData = async (user) => {
    firebase
      .database()
      .ref("/users/" + user.uid)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          this.setState({
            isLoggedIn: true,
            isLoadingApp: false,
            authError: "",
            name: snapshot.val().name,
            api_key: snapshot.val().api_key,
            binance_api_key: snapshot.val().binance_api_key
              ? snapshot.val().binance_api_key
              : "",
            kucoin_api_key: snapshot.val().kucoin_api_key
              ? snapshot.val().kucoin_api_key
              : "",
            api_secret: snapshot.val().api_secret,
            nickName: snapshot.val().nickName ? snapshot.val().nickName : "",
            isProUser: snapshot.val().isProUser
              ? snapshot.val().isProUser
              : false,
            isProPlusUser: snapshot.val().isProPlusUser
              ? snapshot.val().isProPlusUser
              : false,
            realTimeData: snapshot.val().realTimeData,
            telegram_id: snapshot.val().telegram_id,
            maxBot: snapshot.val().maxBot ? snapshot.val().maxBot : 0,
            isRestricted: snapshot.val().isRestricted,
            telegram_notifications: snapshot.val().telegram_notifications
              ? snapshot.val().telegram_notifications
              : this.state.telegram_notifications,
          });
          if (snapshot.val().isRestricted) {
            this.setState({
              alert: {
                isAvailable: true,
                msg: "You are not allow to create new bots.",
                type: "warning",
              },
            });
          }

          // if (snapshot.val().isRestricted && this.state.usersCount < 300) {
          //   firebase
          //     .database()
          //     .ref("/users/" + user.uid)
          //     .update({
          //       isRestricted: false,
          //     });
          // }
          // this.getNotifications();
        } else {
          this.setState({
            isLoggedIn: false,
            isLoadingApp: false,
            name: "",
            api_key: "",
            telegram_id: "",
            email: "",
            authError: "Auth error. Please Try again.",
          });
        }
      });
  };
  signOut = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        // console.log("user SignOut sucess");
      })
      .catch(function (error) {
        console.log(error);
      });
    this.setState({ user: null, isLoggedIn: false });
  };
  signIn = () => {
    var provider = new firebase.auth.GoogleAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        if (!result.additionalUserInfo.isNewUser) {
          firebase
            .database()
            .ref("/users/" + result.user.uid)
            .update({
              last_logged_in: Date.now(),
            });
        } else {
          firebase
            .database()
            .ref("/users/" + result.user.uid)
            .set({
              email: result.user.email,
              name: result.user.displayName,
              created_at: Date.now(),
              api_key: "",
              api_secret: { api_key_data: "", secret_key: "" },
              telegram_id: "",
              isRestricted: false,
              telegram_notifications: {
                filled: true,
                pending: true,
                cancelled: true,
              },
              maxBot: 15,
            });
          var usersCountRef = firebase.database().ref("usersCount").push();

          usersCountRef.set({
            displayId: (this.state.usersCount + 1).toString(),
          });
        }
        // console.log("user signed in");
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  render() {
    return (
      <Context.Provider
        value={{
          ...this.state,
          signIn: this.signIn,
          signOut: this.signOut,
          setIsRestricted: (val) => this.setState({ isRestricted: val }),
          setGetBotDataOn: (val) => this.setState({ isGetBotDataOn: val }),
          closeBanner: () => this.setState({ isBannerDisplay: false }),
          getNotifications: this.getNotifications,
          getBotData: this.getBotData,
          setAlert: (val, msg, type) =>
            this.setState({
              alert: {
                isAvailable: val,
                msg: msg,
                type: type,
              },
            }),
        }}
      >
        {this.props.children}
      </Context.Provider>
    );
  }
}

export { ContextProvider, Context };
